import React from 'react'

const AccountingIconLg = () => {
    return (
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.77778 23H13.2222C18.7778 23 21 20.8 21 15.3V8.7C21 3.2 18.7778 1 13.2222 1H8.77778C3.22222 1 1 3.2 1 8.7V15.3C1 20.8 3.22222 23 8.77778 23Z" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 7.13438V8.23438C16 9.13638 15.2556 9.88442 14.3333 9.88442H7.66667C6.75556 9.88442 6 9.14738 6 8.23438V7.13438C6 6.23238 6.74444 5.48438 7.66667 5.48438H14.3333C15.2556 5.48438 16 6.22138 16 7.13438Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.70605 14.2031H6.72017" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.9941 14.2031H11.0083" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.2822 14.2031H15.2963" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.70605 18.0469H6.72017" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.9941 18.0469H11.0083" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.2822 18.0469H15.2963" stroke="black" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default AccountingIconLg